import { combineReducers } from 'redux';
import { actions } from './Actions';

const initialState = {
  quote: {
		steps: [],
	},
};

const quoteReducer = (state = initialState.quote, action) => {
  switch (action.type) {
    case actions.setSteps:
      return {
				...state,
				steps: action.steps,
			};
    default:
      return state;
  }
};

const reducers = (state, action) => {
  return combineReducers({
    quote: quoteReducer,
  })(state, action);
}

export default reducers;
